/* eslint-disable sort-keys-fix/sort-keys-fix */

/* MUI */
import { Switch } from '@mui/material';
import { styled } from '@mui/material/styles';

/*  React  */
import React from 'react';

export const AuvikSwitch = styled((props) => (
    <Switch
        focusVisibleClassName=".Mui-focusVisible"
        disableRipple
        {...props}
    />
))(({ theme }) => ({
    height: '20px',
    width: '36px',
    padding: 0,
    '& .MuiSwitch-switchBase': {
        margin: '2px',
        padding: 0,
        transitionDuration: '300ms',
        transform: 'translateX(0px)',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: theme.palette.switchAuvik.baseChecked,
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.switchAuvik.baseTrackBackground,
                border: 0,
                opacity: 1
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5
            }
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            border: `6px solid ${theme.palette.switchAuvik.baseFocusBorder}`,
            color: theme.palette.switchAuvik.baseFocusColor
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.switchAuvik.baseDisabled
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7
        }
    },
    '& .MuiSwitch-thumb': {
        backgroundColor: theme.palette.switchAuvik.thumbBackground,
        boxSizing: 'border-box',
        color: theme.palette.switchAuvik.thumbColor,
        height: '16px',
        width: '16px'
    },
    '& .MuiSwitch-track': {
        backgroundColor: theme.palette.switchAuvik.trackBackground,
        borderRadius: '13px',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500
        })
    }
}));
